/**
 * EMZI NEXUS V6.4 - Live Studio V2
 * Step 2: Objective Selection
 */

import React, { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { EMZI_SPACING, EMZI_RADIUS } from '../../../styles/emziCI';

const OBJECTIVES = [
  { id: 'sales', icon: '💰', name: { en: 'Sales', ms: 'Jualan', bm: 'Jualan', urban: 'Sales' }, desc: { en: 'Drive purchases during live', ms: 'Dorong pembelian semasa live', bm: 'Dorong pembelian semasa live', urban: 'Drive purchases during live' } },
  { id: 'branding', icon: '🎨', name: { en: 'Branding', ms: 'Penjenamaan', bm: 'Penjenamaan', urban: 'Branding' }, desc: { en: 'Build brand awareness', ms: 'Bina kesedaran jenama', bm: 'Bina kesedaran jenama', urban: 'Build brand awareness' } },
  { id: 'awareness', icon: '📢', name: { en: 'Awareness', ms: 'Kesedaran', bm: 'Kesedaran', urban: 'Awareness' }, desc: { en: 'Spread the word', ms: 'Sebarkan maklumat', bm: 'Sebarkan maklumat', urban: 'Spread the word' } },
  { id: 'engagement', icon: '💬', name: { en: 'Engagement', ms: 'Penglibatan', bm: 'Penglibatan', urban: 'Engagement' }, desc: { en: 'Build community', ms: 'Bina komuniti', bm: 'Bina komuniti', urban: 'Build community' } }
];

const Step2Objective = ({ sessionId, sessionData, onComplete, onBack, setError }) => {
  const { language } = useLanguage();
  const [objective, setObjective] = useState(sessionData?.objective || null);

  const getText = (key) => {
    const translations = {
      en: { title: 'What is your live objective?', subtitle: 'Select the main goal for your live session', continueBtn: 'Continue to Audience →' },
      ms: { title: 'Apa objektif live anda?', subtitle: 'Pilih matlamat utama untuk sesi live anda', continueBtn: 'Teruskan ke Audiens →' },
      bm: { title: 'Apa objektif live anda?', subtitle: 'Pilih matlamat utama untuk sesi live anda', continueBtn: 'Teruskan ke Audiens →' },
      urban: { title: 'What is your live objective?', subtitle: 'Select main goal untuk live session anda', continueBtn: 'Continue ke Audience →' }
    };
    return translations[language]?.[key] || translations.en[key];
  };

  const handleContinue = () => {
    if (!objective) {
      setError(language === 'bm' ? 'Sila pilih objektif' : 'Please select an objective');
      return;
    }
    setError(null);
    onComplete({ objective });
  };

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ marginBottom: EMZI_SPACING.xl, textAlign: 'center' }}>
        <h1 style={{ fontSize: '22px', fontWeight: '700', marginBottom: EMZI_SPACING.sm, color: '#fff' }}>
          🎯 {getText('title')}
        </h1>
        <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.9)' }}>{getText('subtitle')}</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
        {OBJECTIVES.map(obj => (
          <Card
            key={obj.id}
            onClick={() => setObjective(obj.id)}
            style={{
              cursor: 'pointer',
              borderRadius: EMZI_RADIUS.md,
              border: objective === obj.id ? '3px solid #F89B29' : '2px solid transparent',
              background: objective === obj.id ? '#FFF5E6' : '#fff',
              transition: 'all 0.2s'
            }}
          >
            <CardContent style={{ padding: '24px', textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>{obj.icon}</div>
              <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                {obj.name[language] || obj.name.en}
              </h3>
              <p style={{ fontSize: '13px', color: '#666' }}>{obj.desc[language] || obj.desc.en}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
        <button onClick={onBack} style={{ flex: 1, padding: '14px', background: '#fff', border: '2px solid #0e67a2', borderRadius: '10px', color: '#0e67a2', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}>← Back</button>
        <button onClick={handleContinue} style={{ flex: 2, padding: '14px', background: '#F7941E', border: 'none', borderRadius: '10px', color: '#fff', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}>{getText('continueBtn')}</button>
      </div>
    </div>
  );
};

export default Step2Objective;
